/// <reference path="../../../../typings/index.d.ts" />

module Meevo.Plugins.StockLevels {
  angular.module("meevo.plugins.stockLevels", []);
}